import addressApi from '@/api/address'

const YEAR = 2024

// 编码→中文名缓存
const labelCache = new Map()

/**
 * 查询单条编码对应的中文名（命中缓存直接返回，未命中则发请求并缓存查到的结果）
 */
async function resolveLabel(parentCode, targetCode) {
  if (labelCache.has(targetCode)) return
  const list = await addressApi.getAddress({ code: parentCode, year: YEAR })
  const match = list.find((item) => item.Value === targetCode)
  if (match) {
    labelCache.set(targetCode, match.Label)
  }
}

/**
 * 将省/市/县/街道编码转换为中文名称
 * @param {string} provinceCode - 省编码
 * @param {string} cityCode - 市编码
 * @param {string} countyCode - 县/区编码
 * @param {string} townCode - 乡镇/街道编码
 * @returns {Promise<string>} 拼接后的中文地址
 */
export async function convertAddressToChinese(provinceCode, cityCode, countyCode, townCode) {
  await resolveLabel(0, provinceCode)
  await resolveLabel(provinceCode, cityCode)
  await resolveLabel(cityCode, countyCode)
  await resolveLabel(countyCode, townCode)

  return (
    (labelCache.get(provinceCode) || '') +
    (labelCache.get(cityCode) || '') +
    (labelCache.get(countyCode) || '') +
    (labelCache.get(townCode) || '')
  )
}
